module.exports = __webpack_public_path__ + "static/media/no-hidden-fee.6948246e.svg";